import { ref, get, set } from 'firebase/database';
import { getDoc, doc, collection, getDocs } from 'firebase/firestore';

export function getUser(fb, callback, timeoutCallback) {
    var callSuccessful = false

    if (timeoutCallback) {
      setTimeout(() => {
        if (!callSuccessful) {
          if (timeoutCallback)
            timeoutCallback()
        }
      },
      8000);
    }

    fb.state = 'Fetching user'
    
    const userRef = ref(fb.database, 'users/' + fb.user.uid);
    get(userRef)
      .then((snapshot) => {
        callSuccessful = true
        const data = snapshot.val();
        callback(data);
      });
}

export function setUserField(fb, field, fieldValue, callback) {
  const fieldRef = ref(fb.database, 'users/' + fb.user.uid + '/' + field);
  set(fieldRef, fieldValue)
    .then(() => {
      if (callback) {
        callback();
      }
    });
}

var lastFetchedTeamFromServer = null;
const cacheTimeout = 5 * 60 * 1000;

export function fetchTeamFromCache(fb, teamId, callback) {
  const teamRef = doc(fb.firestore, 'teams', teamId);
  getDoc(teamRef)
    .then((docSnapshot) => {
      callback(docSnapshot);
    });
}

export function fetchTeamFromServer(fb, teamId, callback) {
  const teamRef = doc(fb.firestore, 'teams', teamId);
  getDoc(teamRef)
    .then((docSnapshot) => {
      lastFetchedTeamFromServer = new Date().getTime();
      callback(docSnapshot);
    });
}

export function getUserAndTeam(fb, callback, timeoutCallback) {
    var callSuccessful = false

    if (timeoutCallback) {
      setTimeout(() => {
        if (!callSuccessful) {
          if (timeoutCallback)
            timeoutCallback()
        }
      },
      8000);
    }

    getUser(fb, (user) => {
        var teamId = (user && user.team) ? user.team : null;

        if (!teamId) {
            callSuccessful = true;

            callback(user, null)
            return
        }

        const getFromServer = !lastFetchedTeamFromServer || (new Date().getTime() - lastFetchedTeamFromServer) > cacheTimeout || !fb.firestorePersistenceEnabled;

        if (getFromServer) {
          fb.state = 'Fetching team from server 1'

          fetchTeamFromServer(fb, teamId, (docSnapshot) => {
            callSuccessful = true;

            if (docSnapshot.exists()) {
              var team = docSnapshot.data();
              callback(user, team)
            }
            else {
              alert("Attempted to fetch team from server but it doesn't exist")
            }
          })
        }
        else {
          try {
            fb.state = 'Fetching team from cache'

            fetchTeamFromCache(fb, teamId, (docSnapshot) => {
              if (docSnapshot.exists()) {
                callSuccessful = true;

                var team = docSnapshot.data();
                callback(user, team)
              }
            })
          }
          catch(e) {

            fb.state = 'Fetching team from server 2'

            fetchTeamFromServer(fb, teamId, (docSnapshot) => {
              callSuccessful = true;

              if (docSnapshot.exists()) {
                var team = docSnapshot.data();              
                callback(user, team)
              }
              else {
                alert("Attempted to fetch team from server but it doesn't exist")
              }
            })
          }
        }
    })
  }

  export function getTeams(fb, callback) {
      // Note: This uses the old Firestore API - you may need to update this too
      // For now, keeping it as is since it's using collection().get()
      const teamsRef = collection(fb.firestore, 'teams');
      getDocs(teamsRef)
        .then((snapshot) => {
          callback(snapshot);
        });
}
